import {DocumentableApplication, isProductApplication} from "../resources/documentable"
import {Assignee} from "../resources/application"
import {hasPermission, useIsAllowedToEvaluate, useIsManageResubmitApplication} from "./permission"
import {useIsUnitUser} from "./auth"

export function documentableHasPermission(
	application: DocumentableApplication,
	resource: string,
	action: string
): boolean {
	const prefix = isProductApplication(application) ? "productApplication" : "application"
	return hasPermission(`${prefix}.${resource}`, action)
}

export function useDocumentableIsAllowUpdateDocument(application: DocumentableApplication): boolean {
	const orgId = application.relationships.org.data.id
	const assignee = application.attributes.assignee ?? Assignee.Unit
	const hasDocumentUpdate = documentableHasPermission(application, "document", "update")
	if (isProductApplication(application)) {
		return hasDocumentUpdate
	}
	return hasDocumentUpdate && useIsManageResubmitApplication(orgId, assignee)
}

export function useDocumentableIsAllowedToEvaluate(
	application: DocumentableApplication,
	forceAssigneeCheck: boolean
): boolean {
	const isUnitUser = useIsUnitUser()
	const isAllowedToEvaluate = useIsAllowedToEvaluate(
		application.relationships.org.data.id,
		forceAssigneeCheck,
		application.attributes.assignee
	)
	if (isProductApplication(application)) {
		return isUnitUser
	}
	return isAllowedToEvaluate
}
